var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrow1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 52,
    viewBox: "0 0 64 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2879_7158)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.16009 28.8943C7.85214 25.5245 15.0457 23.1191 22.4346 21.7455C29.8235 20.3719 37.3215 20.0175 44.7881 20.6875C48.9928 21.0631 53.142 21.8195 57.2464 22.8156C57.4565 22.8674 57.8769 22.9484 58.0244 22.7288C58.172 22.5092 57.8179 22.3313 57.6592 22.2895C50.2109 20.2938 42.3713 19.5249 34.6883 19.7641C27.0255 20.0026 19.4078 21.2706 12.1211 23.5759C8.01368 24.8699 4.02122 26.4943 0.185572 28.4291C-0.0642504 28.5542 0.18813 28.7905 0.335048 28.8659C0.575349 28.9897 0.91542 29.0153 1.16009 28.8943V28.8943Z",
    fill: "#344157"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.5643 19.4249C55.7886 19.9338 56.9997 20.4725 58.1899 21.0505C58.7645 21.3303 59.3339 21.6143 59.8984 21.9091C60.3833 22.1618 60.9632 22.3856 61.3733 22.754C61.7833 23.1225 61.7172 23.5051 61.2184 23.7168C60.6486 23.9551 60.0409 24.1311 59.4573 24.334C58.2218 24.7678 56.9844 25.1909 55.7638 25.6574C55.5337 25.7458 55.5006 25.9225 55.6969 26.0785C55.9072 26.2473 56.2914 26.2991 56.5447 26.2177C57.9376 25.77 59.3173 25.2709 60.6989 24.7825C61.4759 24.507 63.6242 24.0598 62.6809 22.8199C62.3421 22.373 61.8025 22.125 61.3201 21.867C60.67 21.5209 60.0124 21.1845 59.3527 20.86C58.0098 20.1975 56.6424 19.5824 55.2584 19.0117C55.0233 18.913 54.6439 18.8212 54.4133 18.9841C54.1969 19.1372 54.3745 19.3497 54.5658 19.4288L54.5643 19.4249Z",
    fill: "#344157"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2879_7158"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 55.3093,
    height: 31.4603,
    fill: "white",
    transform: "translate(12.8496) rotate(24.1068)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.30a3863d.svg";
export { ForwardRef as ReactComponent };